var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "bj-modal",
    {
      attrs: { size: "auto", title: "Take-over assign" },
      model: {
        value: _vm.takeOverAssign.visible,
        callback: function($$v) {
          _vm.$set(_vm.takeOverAssign, "visible", $$v)
        },
        expression: "takeOverAssign.visible"
      }
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c(
          "div",
          { staticClass: "row gutter-sm" },
          [
            _c(
              "q-field",
              { staticClass: "col-auto" },
              [
                _c("q-select", {
                  attrs: {
                    "float-label": "Choose a business member",
                    options: _vm.takeOverAssignData.selectOptions
                  },
                  model: {
                    value: _vm.takeOverAssignData.newAsignee,
                    callback: function($$v) {
                      _vm.$set(_vm.takeOverAssignData, "newAsignee", $$v)
                    },
                    expression: "takeOverAssignData.newAsignee"
                  }
                }),
                _vm.takeOverAssignData.currentAgent &&
                _vm.takeOverAssignData.newAsignee
                  ? _c("span", [
                      _vm._v(
                        "\n          Current agent " +
                          _vm._s(_vm.takeOverAssignData.currentAgent) +
                          " will receive a system cancellation message\n        "
                      )
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-auto" },
              [
                _c("q-btn", {
                  attrs: {
                    disabled: !_vm.takeOverAssignData.newAsignee,
                    outline: "",
                    label: "Take-over Assign"
                  },
                  on: { click: _vm.submitTakeOverAssign }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }